export default __webpack_public_path__ + "static/media/other2-big.ea8e6be2.jpg";